module.exports = __webpack_public_path__ + "img/examine.8eecfa8e.png";